// Angular
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Subject } from "rxjs/Subject";


@Component({
    selector: 'app-attachment-without-filter',
    templateUrl: './attachment.component.html',
    styleUrls: ['./attachment.component.scss']
})

export class AttachmentWithoutCropComponent implements OnInit {

    @Input() cta: string;
    @Input() accept: string;
    @Input() isGuide: boolean
    @Output() onChange: EventEmitter<any>;
    @Input()
    parentSubject: Subject<any>;
    public file: File;
    public imgSrc;
    public thumbnail: any;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    constructor() {
        this.accept = 'image/*,video/*';
        this.onChange = new EventEmitter();

    }
    ngOnInit() {

        this.cta = this.cta == undefined ? 'Drop files here or click to upload' : this.cta;
        this.isGuide = this.isGuide == undefined ? true : false;
        if (this.parentSubject) {
            this.parentSubject.subscribe(event => {
                this.thumbnail = null
                this.file = null
            })

        }
    }

    public upload(event): void {
        if (!event.target.files.length) {
            return;
        }

        this.file = event.target.files.item(0);
        if (this.file.type.match('image')) {

            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onloadend = () => {
                this.thumbnail = reader.result;

                const image = new Image();
                image.src = this.thumbnail;
                this.imgSrc = image.src;
                image.onload = () => {
                    this.onChange.emit({
                        file: this.file,
                        width: image.width,
                        height: image.height,
                        type: 'image'
                    });
                };
            };
        } else {
            this.onChange.emit({
                file: this.file,
                type: 'video'
            });
        }
    }

    showCropper = false;
    fileChangeEvent(event: any): void {
        if (!event.target.files.length) {
            return;
        }
        // this.imageChangedEvent = event;
        this.file = event.target.files.item(0);
        this.showCropper = false;
        let ext = this.file.type.substr(this.file.type.lastIndexOf('.') + 1);
        if (this.file.type.match('image')) {
            if (ext.match('gif'))
            {
                this.showCropper = false;
            }
            else
            {
                this.imageChangedEvent = event;
                this.showCropper = true;
            }
            // this.imageChangedEvent = event;
            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onloadend = () => {
                this.thumbnail = reader.result;

                const image = new Image();
                image.src = this.thumbnail;
                this.imgSrc = image.src;
                image.onload = () => {
                    this.onChange.emit({
                        file: this.file,
                        width: image.width,
                        height: image.height,
                        type: 'image',
                        thumbnail:this.thumbnail
                    });
                };
            };
        } else {

            var _CANVAS = <HTMLCanvasElement>document.querySelector("#video-canvas"),
                _CTX = _CANVAS.getContext("2d"),
                _VIDEO = <HTMLVideoElement>document.querySelector("#main-video");
            // Object Url as the video source
            document.querySelector("#main-video source").setAttribute('src', URL.createObjectURL(this.file));
            _VIDEO.currentTime = 1

            // Load the video and show it
            _VIDEO.load();
            _VIDEO.style.display = 'inline';
            // Load metadata of the video to get video duration and dimensions
            _VIDEO.addEventListener('loadedmetadata', function () {
                var video_duration = _VIDEO.duration,
                    duration_options_html = '';

                // Set options in dropdown at 4 second interval
                for (var i = 0; i < Math.floor(video_duration); i = i + 4) {
                    duration_options_html += '<option value="' + i + '">' + i + '</option>';
                }


                _CANVAS.width = _VIDEO.videoWidth;
                _CANVAS.height = _VIDEO.videoHeight;


            });


            setTimeout(() => {
                _CTX.drawImage(_VIDEO, 0, 0, _VIDEO.videoWidth, _VIDEO.videoHeight);
                var dataURI = _CANVAS.toDataURL()

                var byteString = atob(dataURI.split(',')[1]);

                // separate out the mime component
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);

                // create a view into the buffer
                var ia = new Uint8Array(ab);

                // set the bytes of the buffer to the correct values
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                // write the ArrayBuffer to a blob, and you're done
                var blob = new Blob([ab], { type: mimeString });
                console.log("blob",blob);
                this.onChange.emit({
                    file: this.file,
                    type: 'video',
                    width: _VIDEO.videoWidth,
                    height: _VIDEO.videoHeight,
                    thumbnail: blob
                });

            }, 2000)


        }
    }
    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);

        // create a view into the buffer
        var ia = new Uint8Array(ab);

        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], { type: mimeString });
        return blob;

    }
    imageCropped(image) {
        this.imgSrc = image.base64;
        this.file = this.dataURLtoFile(image)
        if (this.file.type.match('image')) {



            const reader = new FileReader();
            reader.readAsDataURL(this.file);
            reader.onloadend = () => {
                this.thumbnail = reader.result;

                const image = new Image();
                image.src = this.thumbnail;
                this.imgSrc = image.src;
                image.onload = () => {
                    this.onChange.emit({
                        file: this.file,
                        width: image.width,
                        height: image.height,
                        type: 'image',
                        thumbnail:this.thumbnail
                    });
                };
            };
        } else {
            this.onChange.emit({
                file: this.file,
                type: 'video'
            });
        }
    }
    imageLoaded() {
        // show cropper
    }
    loadImageFailed() {
        // show message
    }
    public remove(): void {
        this.thumbnail = null;
        this.file = null;
        this.onChange.emit(null);
    }
    dataURLtoFile(dataurl) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], this.file.name, { type: mime });
    }
    randomString(length, chars) {
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }
}
